export enum LayoutContentPaneType {
    CONTENT = 'content',
}
export enum LayoutSidebarPaneType {
    SIDEBAR_STICKY_LEFT = 'sidebar-sticky-left',
    SIDEBAR_STICKY_RIGHT = 'sidebar-sticky-right',
    SIDEBAR_INLINE_LEFT = 'sidebar-inline-left',
    SIDEBAR_INLINE_RIGHT = 'sidebar-inline-right',
    SIDEBAR_FIXED = 'sidebar-fixed',
}
export enum LayoutTopPaneType {
    TOP_PANE_STICKY = 'top-pane-sticky',
    TOP_PANE_INLINE = 'top-pane-inline',
    TOP_PANE_FIXED = 'top-pane-fixed',
}
export enum LayoutBottomPaneType {
    BOTTOM_PANE_STICKY = 'bottom-pane-sticky',
    BOTTOM_PANE_INLINE = 'bottom-pane-inline',
    BOTTOM_PANE_FIXED = 'bottom-pane-fixed',
}

export const LAYOUT_PANE_CATEGORIES = ['top-pane', 'sidebar', 'content', 'bottom-pane']
export const KEYWORD_OUTER_CHILDREN = 'fixed'
export const VALID_OUTER_CHILDREN = ['top-pane', 'sidebar', 'bottom-pane']

export type LayoutPaneCategoryType = 'top-pane' | 'sidebar' | 'content' | 'bottom-pane'
export type LayoutPaneSubtype = LayoutTopPaneType | LayoutSidebarPaneType | LayoutContentPaneType | LayoutBottomPaneType
